export default {
  namespaced: true,
  state: {
    bundles: [],
    loading: true,
    currentBundle: null,
    bundleDiscount: null
  },
  actions: {},
  getters: {
    availableBundles(state) {
      return state.bundles
    },
    totalBundle(state, getters, rootState, rootGetters) {
      if (state.currentBundle && rootGetters.getCart) {
        const productIdList = state.currentBundle.products.map((product) => {
          return product.id
        })
        const productInBundle = rootGetters.getCart.filter((cart) => {
          return productIdList.includes(cart.id)
        }, [])
        return productInBundle.reduce((prev, curr) => {
          prev = prev + curr.quantity
          return prev
        }, 0)
      } else {
        return 0
      }
    },
    maxBundle(state, getters) {
      if (state.currentBundle && state.currentBundle.quantity_condition > 0) {
        return Math.ceil(
          getters.totalBundle / state.currentBundle.quantity_condition
        )
      } else {
        return 0
      }
    },
    minBundle(state, getters) {
      if (state.currentBundle && state.currentBundle.quantity_condition > 0) {
        return Math.floor(
          getters.totalBundle / state.currentBundle.quantity_condition
        )
      } else {
        return 0
      }
    }
  },
  mutations: {
    ['SET_BUNDLES']: (state, payload) => {
      state.bundles = payload
    },
    ['SET_LOADING_BUNDLES']: (state, payload) => {
      state.loading = payload
    },
    ['SHOW_BUNDLE_SELECT']: (state, payload) => {
      state.currentBundle = payload
    },
    ['SET_BUNDLE_DISCOUNT']: (state, payload) => {
      state.bundleDiscount = payload
    }
  }
}
